module.exports = __webpack_public_path__ + "static/media/FD-cover.e1cd51a1.png";